if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

;(function (undefined) {
	const defaultConfig = Object.freeze({
		bodyClass: {
			visible: "bm-cookie-consent-visible",
			hidden: ""
		},
		content: {
			title: "Your privacy matters to us!",
			summary: `We use cookies on our website to provide the best possible user experience. Some are required to facilitate functionality while others improve usability, allow personalization, or permit anonymized statistical analysis. Please choose the extent to which you accept the use of cookies. Refer to our <a href="https://staging.binaryminds.com/privacy-policy/" target="_blank">Privacy Policy</a> for further details.`,
			showDetails: "Show details ↓",
			hideDetails: "Hide details ↑",
			details: `

			<h4>Required</h4>

			<p>These cookies provide core functionality and enable security features.</p>

			<h4>Statistics</h4>

			<p>These cookies help us to continually improve our website by better understanding its users and how they navigate our site. All data collected is anonymized.</p>

			<h4>Convenience</h4>

			<p>These cookies are not required, but greatly improve the user experience and facilitate additional functionality.</p>

			<h4>Personalization</h4>

			<p>These cookies allow us to provide personalized content and special offers pertaining to your interests and preferences.</p>
			`,
			buttons: {
				save: {
					text: "Save Selection",
				},
				all: {
					text: "Accept all",
				},
			},
		},
		consents: [
			{
				id: "required",
				text: "Allow Only Where Required",
				disabled: true,
				checked: true,
				callback: [],
			}, {
				id: "all",
				text: "Allow All Cookies",
				disabled: false,
				checked: true,
				callback: [],
			},
		],
		callbacks: {
			init: null,
			showPopup: null,
			hidePopup: null,
			saveChoices: null,
		},
		privacyPolicyLink: {
			url: "https://staging.binaryminds.com/privacy-policy/",
			text: "Privacy policy "
		},
		template: `
			<form id="bm-consent" class="bm-consent" method="post">
				<div class="bm-consent__inner">
					<h3 class="bm-consent__title">{%#o.content.title%}</h3>
					<p>
						{%#o.content.summary%}
					</p>
					<ul class="bm-consent__consents">
						{% for (var i=0; i < o.consents.length; i++) { %}
							<li class="bm-consent__consent">
								<input
									type="checkbox"
									id="cookie-consent-input-{%=o.consents[i].id%}"
									name="accepted-cookies"
									value="{%=o.consents[i].id%}"
									{% if (o.consents[i].disabled) { %} readonly disabled {% } %}
									{% if (o.consents[i].checked) { %} checked {% } %}>
								<label for="cookie-consent-input-{%=o.consents[i].id%}">
									{%=o.consents[i].text%}
								</label>
							</li>
						{% } %}
					</ul>
					{% if (o.privacyPolicyLink.url) { %}
						<a
							href="{%=o.privacyPolicyLink.url%}"
							target="_blank"
							class="bm-consent__privacy-link">
							{%#o.privacyPolicyLink.text%}
						</a>
					{% } %}
					{% if (o.content.details) { %}
						<div class="bm-consent__details-toggle">
							<button type="button" class="bm-consent__details-toggle-btn">
								{%=o.content.showDetails%}
							</button>
						</div>
						<div class="bm-consent__details" hidden>
							{%#o.content.details%}
						</div>
					{% } %}
					<div class="bm-consent__buttons">
						<button
							type="submit"
							id="bm-consent-save-btn"
							name="save-consent"
							value="save"
							class="bm-consent-btn bm-consent-btn--save">
							{%=o.content.buttons.save.text%}
						</button>
						<button
							type="button"
							id="bm-consent-all-btn"
							name="save-consent"
							value="all"
							class="bm-consent-btn bm-consent-btn--all">
							{%=o.content.buttons.all.text%}
						</button>
					</div>
				</div>
			</form>`,
		cookie: {
			name: "bmCookieChoices",
			domain: undefined,
			path: '/',
			secure: undefined,
			samesite: undefined,
		},
		reload: true,
	});

	const domReady = new Promise(resolve => {
		if ("loading" === document.readyState) {
			document.addEventListener("DOMContentLoaded", resolve);
		} else {
			resolve();
		}
	});

	const getConfig = new Promise((resolve, reject) => {
		if (window.bmCookieNoticeConfig) {
			resolve(composeConfig(window.bmCookieNoticeConfig));
		} else {
			const request = new XMLHttpRequest();
			request.addEventListener("load", function () {
				if (200 === this.status) {
					const config = JSON.parse(this.response);
					resolve(composeConfig(config));
				} else if (404 === this.status) {
					console.warn(
						"No custom configuration for the Cookie Notice found; using defaults."
					);
					resolve(defaultConfig);
				} else {
					console.error(
						"Loading cookie notice configuration file resulted in an error",
						this.statusText
					);
					reject();
				}
			});
			request.addEventListener("error", (err) => {
				console.error(err);
				reject();
			});
			request.open("GET", "/bmcookieconsentconfig.json");
			request.send();
		}
	}).then(config => {
		const acceptedCookies = getCookie(config.cookie.name)?.acceptedCookies;

		if (!acceptedCookies) {
			return config;
		}

		config.consents.forEach(consent => {
			if (!consent.disabled) {
				consent.checked = acceptedCookies.indexOf(consent.id) !== -1;
			}
		});

		return config;
	});

	const createPopup = getConfig.then(config => {
		const wrapper = document.createElement("div");
		wrapper.className = "bm-cookie-notice";
		wrapper.setAttribute("tabindex", "0");
		wrapper.innerHTML = tmpl(config.template, config);
		return wrapper;
	});

	Promise.all([createPopup, getConfig]).then(([popup, config]) => {
		window.BmCookieNotice = new BmCookieNotice(popup, config);

		if (!getCookie(config.cookie.name)) {
			window.BmCookieNotice.show();
		}
	});

	class BmCookieNotice {
		constructor(popup, config) {
			this.popup = popup;
			this.config = Object.freeze(config);

			this.form = this.popup.querySelector("form");
			this.saveBtn = this.form["bm-consent-save-btn"];
			this.allBtn = this.form["bm-consent-all-btn"];

			this.bindEvents();

			this.getChoices();

			if (this.config.callbacks.init) {
				this.config.callbacks.init(this, popup, config);
			}
		}
		bindEvents() {
			this.popup.querySelector(".bm-consent__details-toggle-btn")
				.addEventListener("click", e => {
					const detailsEl = this.popup.querySelector(".bm-consent__details");
					e.preventDefault();

					if (!detailsEl.dataset.visible) {
						this.showDetails();
					} else {
						this.hideDetails();
					}
				});

			this.form.addEventListener("submit", e => {
				e.preventDefault();

				const choices = [];
				this.form.querySelectorAll(":checked")
					.forEach(checkbox => choices.push(checkbox.value));

				this.saveChoices(choices);

				if (this.config.reload) {
					window.location.reload();
				}
			});

			this.form.querySelector("[name='save-consent'][value='all']").addEventListener("click", e => {
				this.form.querySelectorAll("input[type='checkbox']")
					.forEach(checkbox => checkbox.checked = true);
				this.saveChoices(this.getAvailableChoices());

				if (this.config.reload) {
					window.location.reload();
				}
			});
		}
		show() {
			domReady.then(() => {
				if (!this.popup.isConnected) {
					document.body.prepend(this.popup);
				}

				this.popup.removeAttribute("hidden");

				if (this.config.bodyClass.visible) {
					document.body.classList.add(
						this.config.bodyClass.visible
					);
				}

				if (this.config.bodyClass.hidden) {
					document.body.classList.remove(
						this.config.bodyClass.hidden
					);
				}

				this.popup.focus();

				if (this.config.callbacks.showPopup) {
					this.config.callbacks.showPopup(this.popup, this.config);
				}
			});
		}
		hide() {
			this.popup.setAttribute("hidden", "");

			if (this.config.bodyClass.visible) {
				document.body.classList.remove(
					this.config.bodyClass.visible
				);
			}

			if (this.config.bodyClass.hidden) {
				document.body.classList.add(
					this.config.bodyClass.hidden
				);
			}

			if (this.config.callbacks.hidePopup) {
				this.config.callbacks.hidePopup(this.popup, this.config);
			}
		}
		blockCookies() {
			if (this.config.googleAnalyticsIds.length > 0) {
				this.config.googleAnalyticsIds.forEach((id) => {
					window[`ga-disable-${id}`] = true;
				});
			}
			// GA ad features
			if ( window.ga ) {
				ga("set", "allowAdFeatures", false);
			}
			// Facebook pixel
			if ( window.fbq ) {
				fbq("consent", "revoke");
			}

			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'cookies-analytics': 'no',
				'cookies-facebook': 'no',
				'cookies-googleads': 'no',
				event:'cookies-consent'
			});
		}
		allowCookies() {
			if (this.config.googleAnalyticsIds.length > 0) {
				this.config.googleAnalyticsIds.forEach((id) => {
					window[`ga-disable-${id}`] = true;
				});
			}
			// GA ad features
			if ( window.ga ) {
				ga("set", "allowAdFeatures", true);
			}
			// Facebook pixel
			if ( window.fbq ) {
				fbq("consent", "revoke");
			}

			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'cookies-analytics': 'yes',
				'cookies-facebook': 'yes',
				'cookies-googleads': 'yes',
				event:'cookies-consent'
			});
		}
		submitChoices() {}
		saveChoices(choices) {
			const cookieValue = JSON.stringify({
				availableChoices: this.config.consents.map(consent => consent.id),
				acceptedCookies: choices,
				date: new Date(),
			});

			saveCookie({
				name: this.config.cookie.name,
				value: cookieValue,
				domain: this.config.cookie.domain,
				path: this.config.cookie.path,
				secure: this.config.cookie.secure,
				samesite: this.config.cookie.samesite,
			});
		}
		getChoices() {
			return getCookie(this.config.cookie.name)?.acceptedCookies || [];
		}
		getAvailableChoices() {
			return this.config.consents.map(consent => consent.id);
		}
		isCategoryAccepted(category) {
			const choices = this.getChoices();
			return -1 !== choices.indexOf(category);
		}
		showDetails() {
			const detailsEl = this.popup.querySelector(".bm-consent__details");
			const toggleBtn = detailsEl.parentNode.querySelector(".bm-consent__details-toggle-btn");
			detailsEl.removeAttribute("hidden");
			detailsEl.removeAttribute("aria-hidden");
			detailsEl.dataset.visible = true;
			toggleBtn.innerText = this.config.content.hideDetails;
		}
		hideDetails() {
			const detailsEl = this.popup.querySelector(".bm-consent__details");
			const toggleBtn = this.popup.querySelector(".bm-consent__details-toggle-btn");
			detailsEl.setAttribute("hidden", "");
			detailsEl.setAttribute("aria-hidden", "true");
			delete detailsEl.dataset.visible;
			toggleBtn.innerText = this.config.content.showDetails;
		}
	}

	function getCookie(name) {
		const cookies = document.cookie.split(";").filter(cookie => {
			return `${name}=` === cookie.trim().substr(0, name.length + 1);
		});
		const value = cookies[0]?.substr(cookies[0].indexOf("=") + 1);

		if (value) {
			return JSON.parse(decodeURIComponent(value));
		} else {
			return null;
		}
	}

	function saveCookie({
		name,
		value,
		domain,
		path,
		expires,
		secure = true,
		samesite = 'lax',
	}) {
		const cookieParts = [];

		if (!name || !value) {
			throw new Error("Name and value of the cookie are required.");
		}

		cookieParts.push(`${name}=${encodeURIComponent(value)}`);

		if (domain) {
			cookieParts.push(`;domain=${domain}`);
		}

		if (path) {
			cookieParts.push(`;path=${path}`);
		}

		if (expires) {
			cookieParts.push(`;expires=${expires}`);
		} else {
			const nextYear = new Date((new Date()).setFullYear((new Date()).getFullYear() + 1));
			cookieParts.push(`;expires=${nextYear.toUTCString()}`);
		}

		if (secure) {
			cookieParts.push(`;secure`);
		}

		if (samesite) {
			cookieParts.push(`;samesite=${samesite}`);
		}

		document.cookie = cookieParts.join("");
	}

	function composeConfig(newConfig) {
		return extendObject(defaultConfig, newConfig);
	}

	function extendObject(target, source) {
		const mutableTarget = Array.isArray(target) ?
			JSON.parse(JSON.stringify(target)) :
			Object.assign({}, target);

		for (const prop in source) {
			if (undefined === source[prop]) {
				continue;
			}

			if (typeof source[prop] === "object") {
				mutableTarget[prop] = extendObject(mutableTarget[prop], source[prop]);
			} else {
				mutableTarget[prop] = source[prop];
			}
		}

		return mutableTarget;
	}
})();
